import type { HmmRegion } from "@eu.mdotm.api/sphere";
import { createContext } from "react";

export const RegionContext = createContext<{
	region: HmmRegion;
}>({
	region: "EU",
});
